import { RadioGroup } from 'devextreme-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';

class IsAllRadioGroup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: []
        };

        this.changeActive = this.changeActive.bind(this);
    }

    componentDidMount() {
        this.handleLanguage();
    }

    handleLanguage = () => {
        const { languages, options } = this.props;

        let datas = [];

        languages.forEach(element => {
            const newArray = [];

            for (const item of options) {
                const i = Object.assign({}, item);
                const nameParse = (i.name ? JSON.parse(i.name) : '');

                i.name = nameParse[element.languageId];
                newArray.push(i);
            }

            datas = { ...datas, [element.languageId]: newArray };
        });

        this.setState({
            datas
        });
    }

    changeActive(e) {
        const { field } = this.props;
        this.props.updateData({
            [field]: e.value
        });
    }

    render() {
        const { value, currentLanguageActive, readOnly, i18nLabel } = this.props;
        const { datas } = this.state;
        return (
            <div>
                <div className={'dx-field-label'}>{i18n.t(i18nLabel)}</div>
                <div className={'dx-field-value'}>
                    <RadioGroup
                        readOnly={!!readOnly}
                        items={datas[currentLanguageActive]}
                        value={value}
                        layout={'horizontal'}
                        onValueChanged={this.changeActive}
                        displayExpr={'name'}
                        valueExpr={'value'}
                    />
                </div>
            </div>
        );
    }
}

IsAllRadioGroup.propTypes = {
    currentLanguageActive: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any,
    field: PropTypes.string,
    i18nLabel: PropTypes.string,
    updateData: PropTypes.func,
    languages: PropTypes.array,
    options: PropTypes.array
};

export default IsAllRadioGroup;
